import React, { Component } from 'react'
import _ from 'lodash';

// core components
import GridContainer from "components/Grid/GridContainer.jsx";

import { createDoc, getNewDocId } from 'db/doc.js';

import DXFormSectionTable from "./DXFormSectionTable";
import DXFormSection from "./DXFormSection";

import { verifyEmail, verifyPhoneNumber, verifyNumber, verifyLength, verifyDate } from "./DXFormValidator";
import { sumScores, dementiaRiskCheck } from "components/Form/helper.js";
import { uploadFile } from 'helpers/storage';
import { asyncForEach } from 'helpers/async';

const removeState = (obj) => {
  Object.keys(obj).map(key => {
    if (/.*State$/.test(key))
      delete obj[key];
    else if (typeof obj[key] === 'object')
      removeState(obj[key]);
  })
}

class DXFormStep extends Component {

  constructor(props) {
    super(props);

    const { org } = this.props;

    const org_id = org.currentOrg ? org.currentOrg.id : null;
    const { doc_id = org.currentOrg ? getNewDocId(org.currentOrg.id) : null } = this.props;

    this.state = {
      org_id,
      doc_id,
    }
  }

  change = (event, stateName, typeInfo) => {
    // console.log('stateName = ', stateName);
    if (!typeInfo) {
      this.props.setFormValueState(stateName, event.target.value);
      return;
    }

    const { type, params } = typeInfo;

    if (!type) {
      return;
    }

    switch (type) {
      case "email":
        if (verifyEmail(event.target.value)) {
          this.props.setFormValueState(stateName + "State", "success");
        } else {
          this.props.setFormValueState(stateName + "State", "error");
        }
        break;
      case "phone":
        if (verifyPhoneNumber(event.target.value)) {
          this.props.setFormValueState(stateName + "State", "success");
        } else {
          this.props.setFormValueState(stateName + "State", "error");
        }
        break;
      case "length":
        if (verifyLength(event.target.value, params)) {
          this.props.setFormValueState(stateName + "State", "success");
        } else {
          this.props.setFormValueState(stateName + "State", "error");
        }
        break;
      case "number":
        if (verifyNumber(event.target.value, params)) {
          this.props.setFormValueState(stateName + "State", "success");
        } else {
          this.props.setFormValueState(stateName + "State", "error");
        }
        break;
      case "date":
        if (verifyDate(event.target.value)) {
          this.props.setFormValueState(stateName + "State", "success");
        } else {
          this.props.setFormValueState(stateName + "State", "error");
        }
        break;
      default:
        break;
    }
    this.props.setFormValueState(stateName, event.target.value);
  }

  handleChange = name => event => {
    this.setState({ [name]: event.target.checked });
  };

  isValidated = async () => {

    const { form, page } = this.props;
    if (!form.sections) {
      return false;
    }
    const section = form.sections[page];


    // 필수 항목이 있다면 다음으로 넘어가지 않도록 한다.
    if (section && section.type !== 'table' && !this.checkValidate(this.props.form.valueState[section.id])) {
      this.props.showAlertAction({
        message: `넘어가기 전에, 필수 항목을 먼저 입력해주세요`,
        color: 'danger',
      })
      return false;
    }


    // 스크리닝 질문들 체크하기
    const { screen } = section;
    if (screen) {
      console.log("screen = ", screen);
      const valueStateInSection = this.props.form.valueState[section.id];
      removeState(valueStateInSection);
      const sum = sumScores(valueStateInSection);
      if (eval(`${sum} ${screen.condition} ${screen.value}`)) {
        const valueState = this.props.form.valueState[section.id];
        delete valueState.정서;
        this.save({ [section.id]: valueState });
        this.props.jumpToStep(form.sections.length - 1);
      }
    }

    // check if last page isValidated
    if (form.sections.length - 1 !== page) {
      return true;
    }

    if (section && section.type === 'table') {
      if (await this.tableSection.isValidated()) {
        const tableValueState = this.tableSection.getData();
        this.save(tableValueState);
        return true;
      }
      return false;
    } else {
      let result = this.checkValidate(this.props.form.valueState);

      if (!result) {
        return false;
      } else {
        this.save(this.props.form.valueState);
        return true;
      }
    }
  }

  processFiles = async (files) => {
    const { org_id, doc_id } = this.state;
    const fileInfo = [];
    try {
      await asyncForEach(files, async file => {
        const url = await uploadFile(file, `orgs/${org_id}/docs/${doc_id}`);
        fileInfo.push({
          filename: file.name,
          size: file.size,
          type: file.type,
          url: url
        });
      });
      return fileInfo;
    } catch (e) {
      console.error('failed to upload files: ', e);
    }
  }

  save = async (valueState) => {
    removeState(valueState);
    const { org_id, doc_id } = this.state;
    const { target, current_form } = this.props.form;
    const { uid, displayName, photoURL } = this.props.currentUser;

    let score = null;
    let description = null;
    switch (current_form.sku) {
      case "form00": {
        const files = _.get(valueState, '일반.일반.첨부파일');
        console.log('files = ', files);
        if (files && files.length > 0) {
          const fileInfo = await this.processFiles(files);
          console.log('fileInfo: ', fileInfo);
          _.set(valueState, '일반.일반.첨부파일', fileInfo);
        }
        break;
      }
      case "form02_03": {
        score = sumScores(valueState["간이정신상태검사"]);
        const { age, gender } = target;
        const education_years = parseInt(_.get(valueState, '사전질문.사전질문.교육수준'));

        description = dementiaRiskCheck(age, gender, education_years, score) === true
          ? "치매가 의심되어 정밀진단검사를 받아야 합니다"
          : "정상군입니다";

        break;
      }

      case "form02_06": {
        score = sumScores(valueState["수단적일상생활활동"]);
        break
      }

      case "form02_07": {
        score = sumScores(valueState["기본적일상생활활동"]);
        break;
      }

      case "form02_10": {
        score = sumScores(valueState["정서"]);
        break;
      }

      default:
      //do nothing
    }


    return createDoc(org_id, doc_id, {
      valueState,
      reporter: { uid, displayName, photoURL },
      target,
      form: current_form,
      score,
      description
    })
      .catch(e => {
        console.error(e);
        this.props.showAlertAction({
          message: `저장에 실패했습니다.`,
          color: 'danger',
        })
        throw e
      })
  }

  checkValidate = (obj) => {
    if (typeof obj !== 'object' || obj === null) {
      return true;
    }

    const keys = Object.keys(obj);
    console.log('keys = ', keys);
    for (var key of keys) {
      if ((/.*State$/.test(key))) {
        if (obj[key] === 'error') {
          return false;
        }
      }
      if (obj.hasOwnProperty(key)) {
        console.log('hasOwnProperty = ', obj.hasOwnProperty(key));
        if (typeof obj[key] === 'object' && obj[key] !== null) {
          if (this.checkValidate(obj[key])) {
            continue;
          } else {
            return false;
          }
        }
      }
    }

    return true;
  }

  renderSection = (pid, section) => {
    return <DXFormSection
      key={`${pid}${section.id}`}
      pid={pid}
      section={section}
      form={this.props.form.current_form}
      valueState={this.props.form.valueState}
      setFormValueState={this.props.setFormValueState}
      onChange={this.change}
      classes={this.props.classes}
    />
  }

  renderSections = (pid, pSection) => {
    const { sections = [], description } = pSection;
    return <div>
      <h5><pre style={{
        whiteSpace: 'pre-wrap',
        wordWrap: "break-word"
      }}>{description}</pre></h5>
      <GridContainer>
        {
          sections.map(section => this.renderSection(pid, section))
        }
        {/* {
          this.props?.form?.current_form?.sku === 'form02_03'
            ? this.renderSumForForm02_03()
            : null
        } */}
        {
          this.props?.form?.current_form?.sku === 'form02_06'
            ? this.renderSumForForm02_06()
            : null
        }
        {
          this.props?.form?.current_form?.sku === 'form02_07'
            ? this.renderSumForForm02_07()
            : null
        }
        {
          this.props?.form?.current_form?.sku === 'form02_13'
            ? this.renderSumForForm02_13()
            : null
        }
        {
          this.props?.form?.current_form?.sku === 'form02_10'
            ? this.renderSumForForm02_10()
            : null
        }


      </GridContainer>
    </div>
  }

  /*****************************
   * Table type rendering
   */

  renderForm02_02 = (pid, section) => {
    return <DXFormSectionTable
      pid={pid}
      section={section}
      ref={r => this.tableSection = r}
      showAlertAction={this.props.showAlertAction}
      classes={this.props.classes}
    />
  }

  renderSumForForm02_03 = () => {
    const { valueState: { 간이정신상태검사, 사전질문 } } = this.props.form;
    const { gender, age } = this.props.target;
    const educationYears = parseInt(사전질문?.사전질문?.교육수준);
    const score = sumScores(간이정신상태검사);

    const isRisky = dementiaRiskCheck(age, gender, educationYears, score) === true;
    const description = isRisky
      ? "치매가 의심되어 정밀진단검사를 받아야 합니다"
      : "정상군입니다";

    return <div className={`font-weight-bold text-center ${isRisky ? 'text-danger' : 'text-info'}`}>
      <h3>총점: {score} / 30점 ({description})</h3>
    </div>
  }


  renderSumForForm02_06 = () => {
    const { valueState: { 수단적일상생활활동 } } = this.props.form;

    // console.log('수단적일상생활활동', 수단적일상생활활동);

    const sum잠재능력 = _.sumBy(Object.values(수단적일상생활활동), (o) => Number(o.잠재능력)) || 0;
    const sum현재실행 = _.sumBy(Object.values(수단적일상생활활동), (o) => Number(o.현재실행)) || 0;

    // console.log('sum잠재능력', sum잠재능력);
    // console.log('sum현재실행', sum현재실행);

    return <div>
      <h4>현재실행 {sum현재실행} / 45</h4>
      <h4>잠재능력 {sum잠재능력} / 45</h4>
    </div>
  }

  renderSumForForm02_07 = () => {
    console.log('valueState', this.props.form.valueState);
    const { valueState: { 기본적일상생활활동 } } = this.props.form;

    // console.log('기본적일상생활활동', 기본적일상생활활동);

    let sum = _.sum(Object.values(기본적일상생활활동).map(item => {
      const key = Object.keys(item).filter(key => !/.*State$/.test(key))[0]
      console.log('key', key);
      console.log('item[key]', item[`${key}`]);
      return item[key] || 0
    }));
    // console.log('sum', sum);

    return <div>
      <h4>총점 {sum} / 24점</h4>
    </div>
  }

  renderSumForForm02_10 = () => {
    const score = sumScores(this.props.form.valueState["정서"]);

    return <div>
      <h4>총점 {score} / 15점 만점</h4>
    </div>
  }

  renderSumForForm02_13 = () => {
    const { valueState: { 정신행동증상 } } = this.props.form;

    console.log('Object.values(정신행동증상)', Object.values(정신행동증상));

    console.log('sumby = ', _.sumBy(Object.values(정신행동증상), (o) => Number(o.증상유무)));

    const sum증상유무 = _.sumBy(Object.values(정신행동증상), (o) => Number(o.증상유무)) || 0;
    const sum심한정도 = _.sumBy(Object.values(정신행동증상), (o) => Number(o.심한정도)) || 0;

    return <div>
      <h4>증상유무: {sum증상유무} / 12</h4>
      <h4>심한정도: {sum심한정도} / 36</h4>
    </div>
  }



  render() {
    const { form, page } = this.props;
    const { targetGroup = null, description = null } = form;

    if (!form.sections) {
      return null;
    }

    const section = form.sections[page];
    const { id: pid } = section;

    console.log('section: ', section);
    return <div style={{
      marginBottom: "10px"
    }}>
      <h4>{targetGroup}</h4>
      <h5><pre style={{
        whiteSpace: 'pre-wrap',
        wordWrap: "break-word"
      }}>{description}</pre></h5>
      {
        section.type === 'table'
          ? this.renderForm02_02(pid, section)
          : this.renderSections(pid, section)
      }
    </div>
  }
}

export default DXFormStep;